import { env } from '@/constants/env'
import axios from 'axios'

export const authorizerApi = axios.create({
  baseURL: env.VITE_APP_AUTHORIZER_URL,
  headers: {
    Authorization: `Bearer ${env.VITE_APP_AUTHORIZER_API_TOKEN}`,
  },
})
